import { useTranslation } from 'react-i18next';

interface PresentationFormatProps {
  presentationForm?: string;
}

export default function ProductPresentationFormat({ presentationForm }: PresentationFormatProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="product-card__presentation-format">
      <span aria-hidden="true">{presentationForm}</span>
      <span className="sr-only">{t('search.hits.productCard.presentationForm') as string} {presentationForm}</span>
    </div>
  );
}
